function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScTrends = function SvgScTrends(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4619 13.9113L20.807 4.55742L19.0705 3.56514L14.0134 12.4151H13.2719L11.7896 10.6857L11.2468 10.0525L10.5264 10.4727L8.74476 11.512L8.45956 11.6784L8.32949 11.9819L6.54779 16.1391L8.38608 16.927L10.0377 13.0732L10.8138 12.6205L12.0527 14.0659L12.3521 14.4151H12.812H14.5937H15.174L15.4619 13.9113ZM4 6V4H2V6H4ZM4 10V8H2V10H4ZM4 14V12H2V14H4ZM4 18V16H2V18H4ZM3 20H2V21V22H3H4V21V20H3ZM8 20H6V22H8V20ZM12 20H10V22H12V20ZM16 20H14V22H16V20ZM20 20H18V22H20V20Z",
    fill: "var(--on-surface)",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }));
};
export default SvgScTrends;